// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__rtscY","content":"NotFound_content__mzPvL","icon":"NotFound_icon__wFuVB","text":"NotFound_text__6jDqf","button":"NotFound_button__o56eC"};